import React, { useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Grid, Box } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	label: {
		color: theme.palette.grey[600],
		minHeight: 18,
		maxWidth: 550,
	},
}))

const ActionsView = (props) => {
	const classes = useStyles()
	const { leftActions, rightActions } = props

	return (
		<Box
			sx={{
				padding: "16px",
				display: "flex",
				justifyContent: "space-between",
				width: "100%",
				height: "80px",
			}}
		>
			<Grid data-testid="left-action">{leftActions}</Grid>
			<Grid data-testid="right-action">{rightActions}</Grid>
		</Box>
	)
}

export default ActionsView
